<script>
import { initValue } from '../index'
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    showTooltip: {
      type: Boolean,
      default: true
    }
  },
  render (h) {
    const purValue = initValue(this.value)
    return <read-text value={purValue} showTooltip={this.showTooltip}></read-text>
  }
}
</script>

<style>

</style>